(function () {
  'use strict';

  angular
    .module('relatorios.saudeFrota', [
      'ui.router',
      'FactoryVfiltroModule',
      'ServiceVfiltroModule',
      'ConstantVfiltroModule'
    ]);
}());
